/** The plain words ride above the poetic title so the orb never reads as a loader. */
export const WEBGL_UNAVAILABLE_LABEL = '3D preview unavailable';
export const WEBGL_UNAVAILABLE_TITLE = 'The vision will not form';
export const WEBGL_UNAVAILABLE_TEXT = "Your browser could not start 3D. Turn on hardware acceleration in your browser's settings, or try another browser.";

/** Release the throwaway context so probing does not consume a viewer's WebGL slot. */
export function webGLAvailable(): boolean {
    try {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('webgl2') || canvas.getContext('webgl');
        context?.getExtension('WEBGL_lose_context')?.loseContext();
        return Boolean(context);
    } catch { return false; }
}

export class WebGLUnavailableError extends Error {
    constructor() {
        super(WEBGL_UNAVAILABLE_TEXT);
        this.name = 'WebGLUnavailableError';
    }
}
